/************
 * Developed by : Shiva Software Solutions
 * Date : 28-06-2021
 * Descriptions : Route Navigation
 * Dependicies : To use @material-ui/core
 ************/
import React, {useContext, useEffect, useRef} from 'react';
import {renderRoutes} from 'react-router-config';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import {Switch, useLocation} from 'react-router-dom';
import {AppSuspense} from '../../index';
import routes from '../../../modules';
import Scrollbar from '../Scrollbar';
import AppContext from '../../utility/AppContext';
import PropTypes from 'prop-types';
import {onGetClientDownloadlist} from '../../../redux/actions';
import AppFooter from '../AppLayout/AppFooter';
import Box from '@material-ui/core/Box';
import {RouteTransition} from '../../../shared/constants/AppEnums';
import AppErrorBoundary from '../AppErrorBoundary';
import IdleTimer from 'react-idle-timer';
import {useDispatch} from 'react-redux';
import {useAuthUser} from '../../utility/AppHooks';
import {AuthType} from '../../../shared/constants/AppEnums';
import {onJWTAuthSignout} from '../../../redux/actions';
import {authRole} from '../../../shared/constants/AppConst';
const TransitionWrapper = ({children}) => {
  const {rtAnim} = useContext(AppContext);
  const location = useLocation();
  if (rtAnim === RouteTransition.NONE) {
    return <>{children}</>;
  }
  const currentKey = location.pathname.split('/')[1] || '/';
  return (
    <TransitionGroup appear enter exit>
      <CSSTransition
        key={currentKey}
        timeout={{enter: 300, exit: 300}}
        classNames={rtAnim}>
        <Switch location={location}>{children}</Switch>
      </CSSTransition>
    </TransitionGroup>
  );
};

TransitionWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
const ContentView = () => {
  const dispatch = useDispatch();
  const user = useAuthUser();
  const idleTimer = useRef();
  const [idletime, setIdleTime] = React.useState({
    timeout: 1000 * 60 * 180, //180 minutes timeout
    showModal: false,
    userLoggedIn: false,
    isTimedOut: false,
  });

  const onAction = (e) => {
    // if(e.target)
    // {
    //   if (e.target.closest('.apexcharts-tooltip') || e.target.closest('.apexcharts-canvas ')) {
    //     return; // Ignore action reset when interacting with tooltip or chart
    //   }
    // }
    if (e.target) {
      // Check if the target itself or any of its parent elements have the class
      let parent = e.target;
    
      while (parent) {
      
        if (parent.classList && (parent.classList.contains('apexcharts-tooltip') || parent.classList.contains('apexcharts-canvas'))) {
          return; // Ignore action reset when interacting with tooltip or chart
        }
        parent = parent.parentElement; // Move to the parent
      }
    }
  
    e.stopPropagation();
    setIdleTime({...idletime, isTimedOut: false});
  };

  const onActive = (e) => {
    // this.setState({isTimedOut: false})
    setIdleTime({...idletime, isTimedOut: false});
  };

  const onIdle = (e) => {
    // const isTimedOut = idletime.isTimedOut
    if (idletime.isTimedOut) {
      // alert("timedd pout ")

      if (user && user.authType === AuthType.JWT_AUTH) {
        window.localStorage.clear();
        window.sessionStorage.clear();
        localStorage.clear();
        sessionStorage.clear();
        dispatch(onJWTAuthSignout());
      }
    } else {
      idleTimer.current.reset();
      setIdleTime({...idletime, isTimedOut: true});
    }
  };
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (
        user &&
        user.credentialid &&
        authRole.admin.includes(user?.role || '')
      ) {
        dispatch(
          onGetClientDownloadlist({
            userCode: user.credentialid,
            clientId: user.clientid,
            offset: 0,
            limit: 10,
          }),
        );
      }
    }, 5 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, []);
  return (
    <Scrollbar>
      <Box
        display='flex'
        flex={1}
        flexDirection='column'
        className='main-content-view'>
        <AppSuspense>
          <AppErrorBoundary>
            <IdleTimer
              ref={idleTimer}
              element={document}
              onActive={onActive}
              onIdle={onIdle}
              onAction={onAction}
              debounce={250}
              timeout={idletime.timeout}
            />
            <TransitionWrapper>{renderRoutes(routes)}</TransitionWrapper>
          </AppErrorBoundary>
        </AppSuspense>
      </Box>
      <AppFooter />
    </Scrollbar>
  );
};

export default ContentView;
